var _a, _b;
import { __decorate, __metadata } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ApiShortQuery } from '@/infrastructure/api-functions/api-short-query.interface';
import { OpenService } from '@patsnap/tahiti-core/services/open-service';
let FilterPatentInFolderServiceImpl = class FilterPatentInFolderServiceImpl {
    async filter(options) {
        const data = await this._apiShortQuery.shortQuery({
            space_id: options.spaceId,
            folder_id: options.folderId,
            wefq: '',
            conditions: {
                general: {
                    logical: 'AND',
                    search: options.patentNo,
                },
            },
            wq: {
                '*': options.patentNo,
                outer_op: 'AND',
            },
        });
        const { qid, condId } = data;
        const params = new URLSearchParams();
        params.set('_', `${Date.now()}`);
        params.set('qid', qid);
        params.set('cond', condId);
        params.set('tab', 'refine');
        const query = params.toString();
        this._openService.open(`/detail/patent/images?spaceId=${options.spaceId}&folderId=${options.folderId}&${query}&page=1`);
    }
};
__decorate([
    inject(ApiShortQuery),
    __metadata("design:type", typeof (_a = typeof ApiShortQuery !== "undefined" && ApiShortQuery) === "function" ? _a : Object)
], FilterPatentInFolderServiceImpl.prototype, "_apiShortQuery", void 0);
__decorate([
    inject(OpenService),
    __metadata("design:type", typeof (_b = typeof OpenService !== "undefined" && OpenService) === "function" ? _b : Object)
], FilterPatentInFolderServiceImpl.prototype, "_openService", void 0);
FilterPatentInFolderServiceImpl = __decorate([
    injectable()
], FilterPatentInFolderServiceImpl);
export { FilterPatentInFolderServiceImpl };
